<template>
	<b-overlay :show="is_load">
		<div class="categ_list" v-if="this.tree.length > 0">
            <categ_node_product :max_depth="1" @set_active="on_set" :with_default="false" :categories="tree"></categ_node_product>
		</div>
	</b-overlay>
</template>

<script>

import categ_node_product from "../../sub/categ_node_product";
export default {
	name: "categ_tree",
	components: {categ_node_product},
	props : {
		categ : {
			type : Object
		}
	},
	data() {
		return {
			is_load: true,
			tree : [],
		}
	},

	created () {
		this.load_categs();
	},

	methods : {
		on_set(categ) {
            categ.is_selected = !categ.is_selected;
			let cur_state = categ.is_selected;
			if(cur_state === false) {
				this.categ.parent_id = 0;
			}
			else {
				this.categ.parent_id = categ.id;
			}
			this.set_active_categ(this.tree,cur_state,parseInt(categ.id));
		},

		set_active_categ(categs,cur_state,skeep_id) {
			let self = this;
			categs.map(item => {

				if(cur_state === true && parseInt(item.id) === skeep_id) {
					item.is_selected = true;
				}

				if(cur_state === false || (cur_state === true && parseInt(item.id) !== skeep_id)) {
					item.is_selected = false;
				}

				if(item.hasOwnProperty("children") && item.children.length > 0) {
					self.set_active_categ(item.children,cur_state,skeep_id);
				}
			})
		},

		async load_categs () {
			this.is_load = true;
			this.tree = [];
			await api.post('/internal/v1/catalog/categories/tree',{
				'exclude_ids' : [parseInt(this.categ.id)],
                'is_active' : false,
                'org_id' : this.categ.restaurant_id,
                'category_parent_id' : parseInt(this.categ.parent_id),
			}).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.tree = data.data;
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		}
	},

	computed : {
		get_tree_active () {

		},
	},
}
</script>

<style scoped>

</style>
